import React from "react";
import "./MyGigs.scss";
import { Link } from "react-router-dom";
import getCurrentUser from "../../utils/getCurrentUser";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import newRequest from "../../utils/newRequest";
import { toast } from "react-toastify";

const MyGigs = () => {
  const currentUser = getCurrentUser();
  const queryClient = useQueryClient();
  const { isLoading, error, data } = useQuery({
    queryKey: ["myGigs"],
    queryFn: () =>
      newRequest.get(`/gigs?userId=${currentUser?._id}`).then((res) => {
        return res.data;
      }),
  });

  console.log(data);
  //mutation for delete
  const mutation = useMutation({
    mutationFn: (id) => {
      return newRequest.delete(`/gigs/${id}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["myGigs"]);
      toast.success("Gig Deleted !");
    },
    onError: (error) => {
      toast.error(
        error?.response?.data?.message ||
          "An error occurred while creating the gig."
      );
    },
  });

  //handle delete
  const handleDelete = (id) => {
    mutation.mutate(id);
  };

  return (
    <div className="mygigs">
      <div className="gigs-container">
        <div className="gigs-top">
          <h1>Gigs</h1>
          <Link className="link" to={"/add"}>
            <button>Add new Gig</button>
          </Link>
        </div>
        <div className="gigs-bottom">
          <table>
            <tr>
              <th>Image</th>
              <th>Title</th>
              <th>Price</th>
              <th>Sales</th>
              <th>Action</th>
            </tr>

            {isLoading
              ? "Loading ..."
              : error
              ? "Something went wrong !"
              : data.map((gig) => (
                  <>
                    <tr key={gig?._id}>
                      <td>
                        <img src={gig?.cover} alt="img" />
                      </td>
                      <td>{gig?.title}</td>
                      <td>
                        {gig?.price}.<sup>00</sup>
                      </td>
                      <td>{gig?.sales}</td>
                      <td>
                        <img
                          src="/img/delete.png"
                          alt="delete"
                          className="delete"
                          onClick={() => handleDelete(gig?._id)}
                        />
                      </td>
                    </tr>
                  </>
                ))}
          </table>
        </div>
      </div>
    </div>
  );
};

export default MyGigs;
